<template>
  <div class="container error">
    <transition appear name="slide-fade">
      <Block id="error">
        <div class="code">
          404
        </div>
        <div class="message">
          {{ $t('notFound') }}
        </div>
        <div class="actions">
          <Btn class="inv" to="Index">
            {{ $t('back') }}
          </Btn>
        </div>
      </Block>
    </transition>
  </div>
</template>

<script>
import Errors from 'views/mixins/Errors'

export default {
  mixins: [Errors],
}
</script>

<i18n>
{
  "de": {
    "back": "Gehen Sie zur Homepage",
    "notFound": "Seite nicht gefunden"
  },
  "en": {
    "back": "Go to homepage",
    "notFound": "Page not found"
  },
  "it": {
    "back": "",
    "notFound": ""
  },
  "lt": {
    "back": "Eiti į pagrindinį puslapį",
    "notFound": "Puslapis nerastas"
  },
  "pl": {
    "back": "Przejdź do strony głównej",
    "notFound": "Nie odnaleziono strony"
  }
}
</i18n>
